__turbopack_context__.v({
  "button": "DateRangeDropdown-module-scss-module__nHazHG__button",
  "picker": "DateRangeDropdown-module-scss-module__nHazHG__picker",
  "popup": "DateRangeDropdown-module-scss-module__nHazHG__popup",
  "submenuPopup": "DateRangeDropdown-module-scss-module__nHazHG__submenuPopup",
});
